// @flow weak

import _ from 'lodash';
import { routeTo } from 'redux-router-kit';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppInvitee from 'app/entities/CliAppInvitee';
import { selectAppId } from 'app/developer-v3/store/shared/selectors';
import { LEGACY_BUILDER_BASE_URL } from 'app/developer-v3/constants';

import type { Dispatch } from 'app/common/types';

export const loadCliApp = _.partial(CliApp.actions.loadEntity, null);

export const loadCliInvitees = () => {
  return (dispatch: Dispatch) => {
    dispatch(CliAppInvitee.actions.resetCollection());
    dispatch(CliAppInvitee.actions.loadCollection());
  };
};

export const promoteApp = (
  appId: number,
  appVersion: string,
  changelog?: string
) => {
  return async (dispatch: Dispatch, getState) => {
    await dispatch(CliApp.actions.promoteApp(appId, appVersion, changelog));

    const state = getState();
    const app = CliApp.selectors.all.entity(appId, state);

    if (CliApp.selectors.isReadyToActivate(app)) {
      dispatch(
        routeTo(
          `${LEGACY_BUILDER_BASE_URL}/cli-app/${appId}/activate/${appVersion}`,
          {
            // Triggers router to use window and open link in new tab
            event: { shiftKey: true },
          }
        )
      );
    }
  };
};

export const resetCurrentAppStatus = () => {
  return (dispatch, getState) => {
    const state = getState();
    const appId = selectAppId(state);
    return appId ? dispatch(CliApp.actions.resetStatus(appId)) : null;
  };
};
